import React, { useEffect, useState } from "react";
import Card from "../Card";
import styles from "./index.module.scss";
import { useParams } from "react-router-dom";
import api from "../../../../../api";
import { Spinner } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import { getFilterCatalogState } from "../../../../../redux/selectors";
import { getCatalogsByType } from "../../../../../redux/reducers";
// interface dataInterface {
//   img: string;
//   title: string;
//   descrip: string;
//   price: number;
//   days: string;
// }
const Layout = () => {
  const params: any = useParams();
  const { catalogs, error, loader } = useAppSelector((state) =>
    getFilterCatalogState(state)
  );
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getCatalogsByType(params.type));
  }, [params]);

  return (
    <div className={styles.layout}>
      {loader ? (
        <div className={styles.loader}>
          <Spinner />
        </div>
      ) : error ? (
        <>Произошла ошибка!</>
      ) : catalogs.catalogs.length == 0 ? (
        <>Пусто</>
      ) : (
        catalogs.catalogs.map(
          (
            { amount, catalogName, image, price, description, catalogId },
            i: any
          ) => (
            <Card
              i={i}
              days={amount}
              descrip={description}
              img={image.imagePath}
              price={price}
              title={catalogName}
              key={catalogId}
            />
          )
        )
      )}
    </div>
  );
};

export default Layout;
